<!--
    预约模块
-->
<template>
  <div id="appoint2" class="appoint-box">
    <div class="appoint">
      <div class="appoint-form">
        <input
          v-model="userName"
          class="halfInput mr-half mb-normal"
          type="text"
          placeholder="请输入姓名"
        />
        <div class="halfInput select mb-normal">
          <select v-model="sex" name="" id="">
            <option
              v-for="(item, index) in sexList"
              :key="index"
              :value="item.value"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
        <input
          v-model="userPhone"
          maxlength="11"
          class="fullInput mb-normal"
          type="text"
          placeholder="请输入手机号"
        />
        <div class="fullInput mb-normal select">
          <select :disabled="true" @change="changeSeries" v-model="carType" name="" id="">
            <option
              v-for="(item, index) in carSeriesList"
              :key="index"
              :value="item.value"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class="clear">
          <div class="halfInput select mr-half mb-normal">
            <select
              @change="changeProvince"
              v-model="provinceCode"
              name=""
              id=""
            >
              <option
                v-for="(item, index) in provinceList"
                :key="index"
                :value="item.value"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
          <div class="halfInput mb-normal select">
            <select @change="changeCity" v-model="cityCode" name="" id="">
              <option
                v-for="(item, index) in cityList"
                :key="index"
                :value="item.value"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="fullInput select">
          <select v-model="storeCode" name="" id="">
            <option
              v-for="(item, index) in storeList"
              :key="index"
              :value="item.value"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>
      <checkbox v-model="checked"></checkbox>
      <div @click="submit" class="submit">确认提交</div>
      <!-- <p class="MazdaTypeRegular">*抽签机会领取截止时间：2022.1.31</p> -->
    </div>
  </div>
</template>
<script>
import checkbox from "./checkbox";
export default {
  components: {
    checkbox,
  },
  data() {
    return {
      userName: "",
      userPhone: "",
      storeCode: "",
      carType: "CX5",
      checked: false,
      verifyCode: "",
      sex: "",
      cityCode: "",
      provinceCode: "",
      sexList: [
        {
          name: "称谓",
          value: "",
        },
        {
          name: "先生",
          value: "先生",
        },
        {
          name: "女士",
          value: "女士",
        },
      ],
      defaultSelectCar: { name: "请选择意向车型", value: "" },
      defaultSelectProvince: { name: "请选择省份", value: "" },
      defaultSelectCity: { name: "请选择城市", value: "" },
      defaultSelectAgent: { name: "请选择经销商", value: "" },
      carSeriesList: [],
      provinceList: [],
      cityList: [],
      codeUrl: "",
      storeList: [],
    };
  },
  created() {
    this.provinceList = [this.defaultSelectProvince];
    this.carSeriesList = [this.defaultSelectCar,{name:"CX5",value:"CX5"}];
    this.cityList = [this.defaultSelectCity];
    this.storeList = [this.defaultSelectAgent];
    //this.initCarSeriesList();
    this.initProvinceList();
  },
  methods: {
    ruleDialog() {
      ruleDialog();
    },
    changeSeries(e) {
      this.provinceCode = "";
      this.cityCode = "";
      this.storeCode = "";
      this.carType = e.target.value;
      this.initProvinceList();
    },
    verifyForm() {
      return new Promise((resolve) => {
        var reg = /^1[3456789]\d{9}$/gi;
        let dialog = this.$dialog;
        if (!this.checked) {
          dialog.alert({
            message: "请勾选免责声明",
          });
        } else if (this.userName == "") {
          dialog.alert({
            message: "请输入姓名",
          });
        } else if (this.aex == "") {
          dialog.alert({
            message: "请选择称谓",
          });
        } else if (this.userPhone == "") {
          dialog.alert({
            message: "请输入手机号",
          });
        } else if (!reg.test(this.userPhone)) {
          dialog.alert({
            message: "请输入正确的手机号",
          });
        } else if (!this.carType) {
          dialog.alert({
            message: "请选择车型",
          });
        } else if (!this.provinceCode) {
          dialog.alert({
            message: "请选择省份",
          });
        } else if (!this.cityCode) {
          dialog.alert({
            message: "请选择城市",
          });
        } else if (!this.storeCode) {
          dialog.alert({
            message: "请选择经销商",
          });
        } else {
          resolve();
        }
      });
    },
    filterCode() {
      let code = "";
      this.carSeriesList.forEach((item, index) => {
        if (item.name == this.carType) {
          code = item.modelCode;
        }
      });
      return code;
    },
    getCodeUrl() {
      this.codeUrl =
        "http://qapi.qunar.com/api/captcha/getImage?device=1&k=RgjR0Yzc&appId=dmf_ad_peri&idx=1&" +
        new Date().getTime();
    },
    submit() {
      this.verifyForm().then(() => {
        let params = {
          province: this.provinceCode,
          sex: this.sex,
          city: this.cityCode,
          phone: this.userPhone,
          name: this.userName,
          carSeries: this.carType,
          agent: this.storeCode,
        };
        this.$axios.post("/changmatwo/keepInfo", params).then((res) => {
          if (res.code == 200) {
            // giftDialog();
            this.$axios
              .get("/changmatwo/addnum?source=lz", {
                source: "lz",
              })
              .then(() => {
                this.$dialog.alert({
                  message: "留资成功",
                });
                this.$emit("startNum");
              });
          } else {
            this.$dialog.alert({
              message: res.message,
            });
          }
        });
      });
    },
    initCarSeriesList() {
      this.$axios.get("/changmatwo/model").then((res) => {
        let carSeriesList = [this.defaultSelectCar];
        res.data.forEach((item) => {
          carSeriesList.push({
            name: item,
            value: item,
            modelCode: item,
          });
        });
        this.carSeriesList = carSeriesList;
      });
    },
    initProvinceList() {
      this.$axios
        .get("/changmatwo/provinces?carSeries=" + this.carType)
        .then((res) => {
          let provinceList = [this.defaultSelectProvince];
          res.data.forEach((item) => {
            provinceList.push({
              name: item,
              value: item,
            });
          });
          this.provinceList = provinceList;
        });
    },
    initCityList(province) {
      this.$axios
        .get(
          "/changmatwo/cities?carSeries=" +
            this.carType +
            "&province=" +
            province
        )
        .then((res) => {
          let cityList = [this.defaultSelectCity];
          res.data.forEach((item) => {
            cityList.push({
              name: item,
              value: item,
            });
          });
          this.cityList = cityList;
        });
    },
    initStoreList(provinceCode, cityCode) {
      this.$axios
        .get(
          "/changmatwo/agents?carSeries=" +
            this.carType +
            "&province=" +
            provinceCode +
            "&city=" +
            cityCode
        )
        .then((res) => {
          let storeList = [this.defaultSelectAgent];
          res.data.forEach((item) => {
            storeList.push({
              name: item,
              value: item,
            });
          });
          this.storeList = storeList;
        });
    },
    changeProvince(e) {
      this.cityCode = "";
      this.storeCode = "";
      this.provinceCode = e.target.value;
      this.initCityList(this.provinceCode);
    },
    changeCity(e) {
      this.storeCode = "";
      this.cityCode = e.target.value;
      this.initStoreList(this.provinceCode, this.cityCode);
    },
  },
};
</script>
<style lang="less" scoped>
* {
  box-sizing: border-box;
}
@font-face {
  font-family: "MazdaTypeRegular";
  src: url("../MazdaTypeRegular.otf");
}
@font-face {
  font-family: "NotoSansCJKscRegular";
  src: url("https://source.qunarzz.com/site/images/wns/NotoSansCJKsc-Regular.otf");
}
.NotoSansCJKscRegular {
  font-family: "NotoSansCJKscRegular";
}
.MazdaTypeRegular {
  font-family: "MazdaTypeRegular";
}
.appoint-box {
  position: relative;
  border-top: 1px solid transparent;
}
.rule-btn {
  border: 1px solid #fff;
  border-top-right-radius: 24px;
  border-bottom-right-radius: 24px;
  padding-left: 5px;
  padding-right: 15px;
  padding-top: 6px;
  padding-bottom: 6px;
  border-left: 0;
  font-size: 16px;
  position: absolute;
  left: 0;
  top: 3px;
  z-index: 10;
  cursor: pointer;
}
.appoint {
  margin-bottom: 10px;
  position: relative;
  width: calc(100% - 32px);
  margin-left: auto;
  margin-right: auto;
  &-box {
    width: 342px;
    margin-left: auto;
    margin-right: auto;
  }
  &-form {
    padding-top: 1px;
    input,
    select {
      display: block;
      border: none;
      outline: none;
      height: 35px;
      background-color: transparent;
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      padding-left: 20px;
      padding-right: 20px;
      color: #fff;
      font-size: 12px;
    }
    input::placeholder,
    select {
      color: #fff;
    }
    .select {
      position: relative;
      select{
        width:100%;
        padding-left: 0;
      }
      &:after {
        content: "";
        display: block;
        position: absolute;
        right: 17px;
        top: 50%;
        width:1px;
        border:6px solid transparent;
        border-top-color:#fff;
        margin-top:-6px;
        background-size: 100% 100%;
      }
    }
    .fullInput {
      width: calc(100% - 2px);
      padding-left: 11px;
      border: 1px solid #fff;
      border-radius: 17px;
    }
    .halfInput {
      width: 146px;
      float: left;
      border: 1px solid #fff;
      padding-left: 11px;
      box-sizing: border-box;
      border-radius: 17px;
    }
    .mr-half {
      margin-right: 14px;
    }
    .mb-normal {
      margin-bottom: 20px;
    }
  }
}
.submit {
  width: 243px;
  margin-left: auto;
  margin-right: auto;
  height: 35px;
  margin-bottom: 12px;
  background-color: #ac413d;
  color: #fff;
  line-height: 35px;
  text-align: center;
  z-index: 10;
  border-radius: 18px;
  margin-top: 18px;
  cursor: pointer;
}
.smscode {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-box-align: center;
  justify-content: space-between;
  margin-left: auto;
  margin-right: auto;
  -webkit-text-size-adjust: center;
  margin-top: 15px;
  padding-left: 0 !important;
  width: calc(100% - 30px);
  margin-left: auto;
  margin-right: auto;
  &-lf {
    width: 156px;
    height: 35px;
    border: 1px solid #b9b9b9;
    text-align: center;
    background-color: #fff0c2;
    border-radius: 3px;
    input {
      text-align: center;
      padding-left: 0;
      width: 162px;
    }
  }
  &-rt {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    -webkit-box-align: center;
    .codeNum {
      width: 93px;
      height: 35px;
      overflow: hidden;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      -webkit-box-align: center;
      justify-content: center;
      -webkit-text-size-adjust: center;
      img {
        height: 35px;
        display: block;
      }
    }
    .refresh {
      width: 20px;
      height: 20px;
      margin-left: 10px;
    }
  }
}
</style>